import { LayoutCanvas } from '../../types/types';
import { capScaleToStageLimit } from './capScaleToStageLimit';
import { normalizeLayoutScale } from './normalizeLayoutScale';

export type LayoutEffectiveScale = { x: number; y: number };

// Resolves the zoom the canvas renders with: bestOfScale fits the whole canvas
// into the workspace (uniform, aspect kept), otherwise scaleX/scaleY apply.
// Non-positive/missing values fall back to 1.
export const getLayoutEffectiveScale = (
  canvas: LayoutCanvas,
  workspaceWidth: number,
  workspaceHeight: number
): LayoutEffectiveScale => {
  if (canvas.bestOfScale) {
    const canFit =
      workspaceWidth > 0 &&
      workspaceHeight > 0 &&
      canvas.width > 0 &&
      canvas.height > 0;

    if (!canFit) {
      return { x: 1, y: 1 };
    }

    const fit = Math.min(
      workspaceWidth / canvas.width,
      workspaceHeight / canvas.height
    );
    return { x: fit, y: fit };
  }

  return {
    x: capScaleToStageLimit(normalizeLayoutScale(canvas.scaleX), canvas.width),
    y: capScaleToStageLimit(normalizeLayoutScale(canvas.scaleY), canvas.height),
  };
};
